import './style.scss';

export function patient_questions_block() {
    const block = document.querySelector('.patient_questions_block');
    if (!block) return;
}

